import React, { useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import PesquisaSatisfacao from "./PesquisaSatisfacao";
import PesquisaSatisfacaoController from "../controller/pesquisa-satisfacao.controller";

interface Props {
  show: any;
  onHide: any;
  handleFinalizar: any;
}

export default function ModalPesquisaSatisfacao({
  show,
  onHide,
  handleFinalizar,
}: Props) {
  const controller = new PesquisaSatisfacaoController();

  const dialogStyle = {
    width: "520px",
    borderRadius: "16px",
    padding: "0",
  };

  useEffect(() => {
    if (show) {
      controller.init();
    }
  }, [show]);

  return (
    <>
      <Dialog
        onHide={() => onHide()}
        visible={show}
        style={dialogStyle}
        draggable={false}
        modal
        closable={false}
        className="pesquisa-satisfacao-dialog"
        footer={
          <div className="pesquisa-satisfacao-footer">
            <Button
              label="Salvar e Continuar"
              icon="pi pi-check"
              className="pesquisa-satisfacao-footer__btn"
              onClick={() => {
                controller.validaSalvar(handleFinalizar);
              }}
            />
          </div>
        }
      >
        <PesquisaSatisfacao controller={controller} />
      </Dialog>
    </>
  );
}
